import React from 'react';
import { Section } from '../ui/Section';
import { AlertCircle, ArrowRight } from 'lucide-react';
export function Problem() {
  return <Section bgColor="blush" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        <div className="text-center mb-4" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-serif mt-[15px] mb-[0px] pt-[0px] pb-[0px]" data-id="element-161">
            Este journal es para vos si...
          </h2>
        </div>

        <div className="grid gap-6 mb-16" data-id="element-162">
          {[<>
              Sentís que repetís los <strong data-id="element-163">mismos patrones</strong> en
              relaciones, familia, trabajo o con vos misma.
            </>, <>
              Sabés que hay <strong data-id="element-164">cosas del pasado</strong> que todavía{' '}
              <strong data-id="element-165">te condicionan</strong>.
            </>, <>
              Te cuesta <strong data-id="element-166">expresar lo que sentís</strong> o poner en
              palabras lo que te pasa.
            </>, <>
              Querés <strong data-id="element-167">entenderte de verdad</strong>, pero no sabés por
              dónde empezar.
            </>].map((item, idx) => <div key={idx} className="flex items-start bg-white/60 p-6 rounded-sm shadow-sm border border-white pt-[15px] pb-[15px] pl-[24px] pr-[24px] mt-[0px] mb-[0px] gap-[16px]" data-id="element-168">
              <div className="mt-1 bg-brand-violet/10 p-2 rounded-full text-brand-violet shrink-0" data-id="element-169">
                <ArrowRight className="w-4 h-4" data-id="element-170" />
              </div>
              <p className="text-brand-dark leading-relaxed" data-id="element-171">{item}</p>
            </div>)}
        </div>

        <div className="bg-white p-8 md:p-12 rounded-sm shadow-card relative overflow-hidden pl-[32px] pr-[32px] pt-[8px] pb-[8px]" data-id="element-172">
          <div className="absolute top-0 left-0 w-1 h-full bg-brand-violet" data-id="element-173"></div>

          <div className="pt-[0px] pb-[0px]" data-id="element-174">
            <p className="text-brand-dark font-medium mb-4" data-id="element-175">
              Y lo peor no es solo seguir igual. Lo peor es sentir que{' '}
              <strong data-id="element-176">ya te pasó antes</strong>, que{' '}
              <strong data-id="element-177">ya prometiste cambiar</strong>, que ya intentaste
              entenderte, pero <strong data-id="element-178">seguís tropezando con lo mismo</strong>.
            </p>
            <p className="text-brand-light italic" data-id="element-179">
              <strong data-id="element-180">No es que te falte fuerza</strong>. No es que seas
              "demasiado sensible". Muchas veces, simplemente,{' '}
              <strong data-id="element-181">nadie te enseñó a mirar de frente lo que te duele</strong>
              .
            </p>
          </div>
        </div>
      </div>
    </Section>;
}